"use client";

import {
  AcceptSvg,
  CheckboxCheckedSvg,
  CheckboxUncheckSvg,
  CopySvg,
  EyeOnSvg,
  GiveMoneySvg,
  ImageSvg,
  LoadingSvg,
  RemoveSvg,
  SearchSvg
} from "@/public/svg";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";
import { FooterTable } from "../../_component";
import {
  getDetailOrder,
  getGroupArea,
  getListOrder,
  getOngkir,
  getShippingMarketplace,
  setOrderToApproval,
  setOrderToCancel,
  setOrderToCompleted,
  setOrderToProcess,
  tracking,
  updateAddressTransaction,
  saveExpiredUrl
} from "@/functions/databaseData";
import currency from "@/functions/currency";
import useModal from "@/functions/useModal";
import { toast } from "react-toastify";
import { Upload } from "lucide-react";
import Input from "@/components/atom/Input";
import Button from "@/components/atom/Button";
import Label from "@/components/sub-atom/Label";
import ContainerModal from "@/components/sub-atom/ContainerModal";
import Divider from "@/components/atom/Divider";
import useAlert from "@/functions/useAlert";
import { format } from "date-fns";
import PaymentCard from "@/components/atom/PaymentCard";
import useHeader from "@/functions/useHeader";
import { useCheckBreakPoint } from "@/functions/usResponsive";
import { ScrollPagination } from "@/components/atom/Pagination";
import { getShippingWeight } from "@/functions/shippingWeight";
import { validasiNameDate } from "@/functions/validasiNameEkspedisi";
import useDelayedRender from "@/functions/useDelayedRender";
import { useScreenshot } from "use-react-screenshot";
import InputTitle from "@/components/sub-atom/InputTitle";
import fetchAPI from "@/functions/fetchAPI";

const settingToast = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

const title = {
  expired: "expired",
  canceled: "canceled",
  booking: "booking",
  ["konfirmasi-order"]: "konfirmasi order",
  ["on-process"]: "process",
  ["on-packing"]: "packing",
  ["on-delivery"]: "On-Delivery",
  received: "received",
  completed: "completed",

  // type payment
  paylater: "paylater",
  payment_gateway: "Via Online",
  COD: "cash on delivery",
  cash: "cash",

  // status pembayaran
  pending: "PENDING",
  paid: "PAID"
};

const colors = {
  expired: "orange",
  canceled: "errorGON",
  booking: "warningGON",
  ["konfirmasi-order"]: "teal",
  ["on-process"]: "teal",
  ["on-packing"]: "cyan",
  ["on-delivery"]: "secondaryGON",
  received: "successGON",
  completed: "primaryGON",

  // type payment
  paylater: "secondary",
  payment_gateway: "primary",
  wallet: "success",
  COD: "greyscale",
  cash: "warning",

  // status pembayaran
  pending: "cyan",
  paid: "successGON"
};

const downloadImage = (image, filename) => {
  const byteString = atob(image.split(",")[1]);
  const mimeString = image.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([ab], { type: mimeString });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url); // Clean up the URL.createObjectURL resource
};

export default function ListOrder() {
  const refScreenshot = useRef(null);
  const fileInputRef = useRef(null);
  const [activeUploadOrderId, setActiveUploadOrderId] = useState(null);
  const [_, takeScreenshot] = useScreenshot();
  const getImage = () =>
    takeScreenshot(refScreenshot.current).then((image) => {
      downloadImage(
        image,
        `daftar_belanja_${format(new Date(), "hh_mm_ss")}.png`
      );
    });

  const shouldRendered = useDelayedRender(300);

  const { session, profile } = useHeader();
  const { openModal, closeModal } = useModal();
  const { showAlert } = useAlert();
  const [showModal, setShowModal] = useState({
    type: "",
    data: []
  });
  const [show, setShow] = useState(0);
  const [allowChangeAddress, setAllowChangeAddress] = useState(false);
  const [chooseBank, setChooseBank] = useState({});

  const [date, setDate] = useState({
    date_from: "",
    date_until: ""
  });
  const [loading, setLoading] = useState({});
  const [datas, setDatas] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [showFilter, setShowFilter] = useState({
    show: false
  });
  const [showAllOrder, setShowAllOrder] = useState(false);

  const headList = [
    "Aksi",
    "Status",
    "Payment",
    "No. Order",
    "Tanggal",
    "Pembeli",
    "Penerima",
    "Level",
    "Total",
    "Resi Pengiriman"
  ];

  useEffect(() => {
    if (session) {
      setLoading((old) => ({
        ...old,
        firstGetDatas: true
      }));
      if (datas?.length <= 0) runGetListOrder();
      if (!datasModals?.code_order) closeModal();
    }
  }, []);

  const runGetListOrder = useCallback(
    async (bool_status = false) => {
      setLoading((old) => ({
        ...old,
        getDatas: true
      }));
      try {
        let payload = {
          date_from: bool_status
            ? `${date?.date_from?.replaceAll("/", "-")}`
            : "",
          date_until: bool_status
            ? `${date?.date_until?.replaceAll("/", "-")}`
            : ""
        };

        const res = await getListOrder({
          id: session?.user?.data?.mitra_id,
          token: session?.user?.token,
          ...payload
        });
        setDatas(res);
      } catch (error) {
        console.log(error?.message);
      } finally {
        setLoading((old) => ({
          ...old,
          getDatas: false,
          firstGetDatas: false
        }));
      }
    },
    [session.user, date]
  );

  async function runGetDetailOrder(item) {
    try {
      const res = await getDetailOrder({
        mitra_id: item?.mitra_id,
        order_id: item?.order_id,
        token: session?.user?.token
      });
      setShowModal({
        type: "detail-order",
        data: {
          ...res,
          order_id: item?.order_id,
          expired_url: item?.expired_url,
          products: res?.products?.sort(
            (a, b) =>
              (!a.product_canceled ? -1 : 1) - (!b.product_canceled ? -1 : 1)
          ),
          otherItem: {
            ...item,
            isAllow:
              item?.isAllow ||
              ((item?.status == "received" || item?.status == "on-delivery") &&
                res?.status_resi_marketplace)
          }
        }
      });
      openModal();
    } catch (error) {
      console.log(error.message);
    }
  }

  const handleUploadResi = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !activeUploadOrderId) return;

    const toastId = toast.loading("Sedang mengunggah resi marketplace...");

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("isExpired", "true");
      formData.append("bucket", "marketplace_resi");
      formData.append("event", "resi");

      const response = await fetch(`/gon-proxy/${process.env.NAME_SPACE}/${process.env.BASE_URL_DATABASE}/upload/public/gon`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Gagal mengunggah file ke server.");
      }

      const resData = await response.json();
      if (resData?.status === "success" && resData?.data?.link) {
        const expiredUrl = resData.data.link;

        const saveRes = await saveExpiredUrl({
          order_id: activeUploadOrderId,
          expired_url: expiredUrl,
          token: session?.user?.token,
        });

        if (saveRes?.status === "success") {
          toast.update(toastId, {
            render: "Resi marketplace berhasil diunggah!",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
          runGetListOrder();
          setShowModal((old) => {
            if (old?.data?.order_id === activeUploadOrderId) {
              return {
                ...old,
                data: {
                  ...old.data,
                  expired_url: expiredUrl
                }
              };
            }
            return old;
          });
        } else {
          throw new Error(saveRes?.message || "Gagal menyimpan URL resi.");
        }
      } else {
        throw new Error(resData?.message || "Format data tidak valid.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.update(toastId, {
        render: `Gagal mengunggah resi: ${error.message}`,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
      setActiveUploadOrderId(null);
    }
  };

  async function handleChangeStatusOrder(item, type) {
    console.log(type);
    async function runChange(item, type, msg = "") {
      try {
        setLoading((old) => ({
          ...old,
          [type]: {
            ...old?.[item?.code_order],
            [item?.code_order]: true
          }
        }));

        const isSemiBlock = profile?.is_semi_block;
        if (isSemiBlock)
          throw new Error(
            "Maaf, akun tidak dapat digunakan untuk menyetujui pesanan karena telah diblokir oleh atasan Anda."
          );

        let res = null;
        let payload = {
          mitra_id: item?.mitra_id,
          order_id: item?.order_id,
          token: session?.user?.token
        };
        if (type == "process") {
          await setOrderToApproval(payload);
          res = await setOrderToProcess(payload);
        } else if (type == "completed") {
          res = await setOrderToCompleted(payload);
        } else {
          if (msg?.length <= 0) throw new Error("Masukkan alasan anda");
          res = await setOrderToCancel({ ...payload, message: msg });
        }

        if (!res.error) {
          runGetListOrder();
          closeModal();
          setAllowChangeAddress(false);
          return toast(res.message, settingToast);
        }
        throw new Error(`Failed ${type} order`);
      } catch (error) {
        toast.error(error?.message, settingToast);
      } finally {
        setLoading((old) => ({
          ...old,
          [type]: {
            ...old?.[item?.code_order],
            [item?.code_order]: false
          }
        }));
      }
    }

    let msg = "";
    let typePayment = item?.type_payment;
    const setAlert = {
      msgToast: `Cancel Order!!`,
      title: "Cancel Orderan",
      desc: () => (
        <div className="flex flex-col gap-4">
          <p className="p1-regular text-greyscaleGON-400">
            <strong className="capitalize">Konfirmasi!</strong> Berikan alasan
            anda meng-cancel orderan {item?.name_recipient}?
          </p>
          <Input
            placeholder="Masukkan alasan"
            onChange={(a) => {
              msg = a;
            }}
          />
        </div>
      ),
      btn: {
        open: {
          text: "Ya, Cancel",
          color: "error",
          onClick: () => runChange(item, type, msg)
        },
        close: {
          text: "Tidak, Batalkan",
          onClick: () => { }
        }
      },
      error: true
    };

    if (type == "cancel")
      return showAlert({
        versiAlert: 2,
        error: setAlert?.error,
        title: setAlert?.title,
        desc: () => setAlert?.desc(),
        descBold: "Konfirmasi!",
        handleClick: {
          open: {
            ...setAlert?.btn?.open,
            hide: false
          },
          close: {
            ...setAlert?.btn?.close,
            hide: false
          }
        }
      });
    return runChange(item, type);
  }

  function handlePaymentOnline(item) {
    function runModal() {
      setShowModal({
        type: "payment-online",
        data: item
      });
      openModal();
    }
    if (!item?.payment_url) {
      return runModal();
    }
    return showAlert({
      colors: "warning",
      title: "Konfirmasi",
      desc: "Anda telah memilih opsi pembayaran sebelumnya. Mohon segera melakukan pembayaran sebelum waktu pembayaran berakhir.",
      handleClick: {
        close: {
          onClick: () => runModal(),
          text: "Ganti Opsi Pembayaran",
          hide: false
        },
        open: {
          onClick: () => window.open(item?.payment_url),
          text: "Bayar Sekarang",
          hide: false
        }
      }
    });
  }

  async function runLacak(item) {
    try {
      const res = await tracking({
        mitra_id: item?.otherItem?.mitra_id,
        order_id: item?.otherItem?.order_id,
        token: session?.user?.token
      });
      if (!res?.error) {
        return setShowModal((old) => ({
          ...old,
          type: "tracking-resi",
          kurir: res?.kurir,
          listTracking: res?.items
        }));
      }

      throw new Error(res?.error?.message ?? res?.error);
    } catch (error) {
      console.log(error.message);
      toast.error(error.message, settingToast);
    }
  }

  const listTypeProduct = useMemo(
    () => [
      {
        id: 0,
        title: "all",
        value: datas,
        status: show == 0 ? "active" : "noActive"
      },
      {
        id: 1,
        title: "booking",
        actionType: "on-process",
        value: datas?.filter((val) => val?.status == "booking"),
        status: show == 1 ? "active" : "noActive",
        handleBTN: { disable: false, title: "Konfirmasi Pesanan" }
      },
      {
        id: 3,
        title: "on-process",
        actionType: "on-packing",
        value: datas?.filter((val) => val?.status == "on-process"),
        status: show == 3 ? "active" : "noActive",
        handleBTN: { disable: false, title: "Kemas Pesanan" }
      },
      {
        id: 4,
        title: "on-packing",
        actionType: "on-delivery",
        value: datas?.filter((val) => val?.status == "on-packing"),
        status: show == 4 ? "active" : "noActive",
        handleBTN: { disable: false, title: "Kirim Pesanan" }
      },
      {
        id: 5,
        title: "on-delivery",
        value: datas?.filter((val) => val?.status == "on-delivery"),
        status: show == 5 ? "active" : "noActive",
        handleBTN: { disable: true, title: "Pesanan dikirim" }
      },
      {
        id: 6,
        title: "received",
        value: datas?.filter((val) => val?.status == "received"),
        status: show == 6 ? "active" : "noActive",
        handleBTN: { disable: true, title: "Pesanan sampai ditujuan" }
      },
      {
        id: 7,
        title: "completed",
        value: datas?.filter((val) => val?.status == "completed"),
        status: show == 7 ? "active" : "noActive",
        handleBTN: { disable: true, title: "Pesanan diterima" }
      },
      {
        id: 8,
        title: "canceled",
        value: datas?.filter((val) => val?.status == "canceled"),
        status: show == 8 ? "active" : "noActive",
        handleBTN: { disable: true, title: "Pesanan dibatalkan" }
      },
      {
        id: 9,
        title: "expired",
        value: datas?.filter((val) => val?.status == "expired"),
        status: show == 9 ? "active" : "noActive",
        handleBTN: { disable: true, title: "Pesanan expired" }
      }
    ],
    [datas, show, loading]
  );

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    const isListOrder = listTypeProduct
      ?.filter((val1) => val1?.id == show)?.[0]
      ?.value?.filter((item) =>
        showFilter?.value
          ? item?.buyyer_info
            ?.toLowerCase()
            ?.includes(showFilter?.value?.toLowerCase())
          : item
      )
      ?.filter((item) => {
        return search?.length > 0
          ? item?.name_recipient
            ?.toLowerCase()
            ?.includes(search?.toLowerCase()) ||
          item?.code_order
            ?.toLowerCase()
            ?.includes(search?.toLowerCase()) ||
          item?.kurir_ekspedisi
            ?.toLowerCase()
            ?.includes(search?.toLowerCase())
          : item;
      });

    return isListOrder?.slice(firstPageIndex, lastPageIndex);
  }, [
    pageSize,
    currentPage,
    search,
    datas,
    showFilter?.value,
    listTypeProduct,
    show
  ]);

  let maxDateRangeFrom = new Date();
  let maxDateRangeUntil = !date.date_from
    ? new Date()
    : new Date(date.date_from);
  maxDateRangeUntil.setDate(maxDateRangeUntil.getDate() + 7);

  const filterByLevel =
    session?.user?.data?.mitra_level == 1
      ? ["distributor", "agen", "reseller"]
      : session?.user?.data?.mitra_level == 2
        ? ["agen", "reseller"]
        : ["reseller"];

  const datasModals = showModal?.data;

  const isMarketplace =
    (datasModals?.resi_marketplace !== undefined &&
      datasModals?.resi_marketplace !== null &&
      datasModals?.resi_marketplace !== "") ||
    (datasModals?.otherItem?.resi_market_place !== undefined &&
      datasModals?.otherItem?.resi_market_place !== null &&
      datasModals?.otherItem?.resi_market_place !== "");

  const breakpoint = useCheckBreakPoint();

  return (
    shouldRendered && (
      <div className={twMerge("flex flex-col gap-4 xs:gap-8")}>
        <div className=" bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8 flex flex-col gap-3 xs:gap-6">
          <div
            className={twMerge(
              "flex justify-between gap-2",
              breakpoint == "ui-laptop" ? "flex-row items-end" : "flex-col"
            )}
          >
            <div
              className="w-full gap-4
        flex flex-col xs:flex-row items-end"
            >
              <Input
                label={"Dari Tanggal"}
                type="date"
                placeholder="dd/mm/yyyy"
                rangeDate={{
                  max: maxDateRangeFrom.toISOString().split("T")[0]
                }}
                value={date.date_from}
                onSubmit={(e) => e.preventDefault()}
                onChange={(val) => {
                  setDate((old) => ({ ...old, date_from: val }));
                }}
              />
              <Input
                label={"Sampai Tanggal"}
                type="date"
                placeholder="dd/mm/yyyy"
                rangeDate={{
                  min: date.date_from,
                  max: maxDateRangeUntil.toISOString().split("T")[0]
                }}
                value={date.date_until}
                onSubmit={(e) => e.preventDefault()}
                onChange={(val) => {
                  setDate((old) => ({ ...old, date_until: val }));
                }}
              />
              <div className="w-full flex gap-3 items-center">
                {!date.date_from && !date.date_until ? null : (
                  <Button
                    className="flex xs:w-max w-full"
                    label="reset"
                    disable={loading?.getDatas}
                    variants="outline"
                    onClick={() => {
                      setDate({ date_from: "", date_until: "" });
                      runGetListOrder();
                    }}
                  />
                )}
                <Button
                  className="flex xs:w-max w-full"
                  label="Tampilkan"
                  loading={loading?.getDatas}
                  disable={loading?.getDatas}
                  onClick={() => {
                    runGetListOrder(true);
                  }}
                />
              </div>
            </div>
            <div className="w-full flex items-center gap-4 justify-end">
              <div className="flex flex-col xs:flex-row w-full gap-4 items-center">
                <Input
                  icon={{
                    left: (props) => <SearchSvg {...props} />
                  }}
                  placeholder="Cari nama penerima atau nomor order"
                  onChange={(val) => setSearch(val)}
                  value={search}
                  onSubmit={(e) => e.preventDefault()}
                  enterKeyHint={"search"}
                />
                <div className="xs:w-max w-full relative inline-block text-left">
                  <Button
                    variants={showFilter?.show ? "outline" : "solid"}
                    className="flex xs:w-max w-full"
                    label={
                      showFilter?.show
                        ? "Reset Filter"
                        : `Filter by ${showFilter?.value?.length > 0
                          ? showFilter?.value
                          : "level"
                        }`
                    }
                    onClick={() =>
                      setShowFilter({
                        show: !showFilter?.show,
                        value: ""
                      })
                    }
                  />
                  {showFilter?.show && (
                    <div
                      className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabindex="-1"
                    >
                      <div className="py-1" role="none">
                        {filterByLevel?.map((item, key) => (
                          <span
                            key={key}
                            onClick={() => {
                              setShowFilter({ show: false, value: item });
                              setCurrentPage(1);
                            }}
                            className="text-gray-700 capitalize block px-4 py-2 text-sm cursor-pointer"
                            role="menuitem"
                            tabindex="-1"
                            id="menu-item-0"
                          >
                            {item}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 xs:p-8 flex flex-col gap-3 xs:gap-6">
          <ScrollPagination
            datas={listTypeProduct}
            className="flex flex-row gap-2 w-full"
            renderItem={({ item, index }) => {
              const colors = {
                active: "primaryGON",
                noActive: "greyscaleGON"
              };
              return (
                <div
                  key={index}
                  onClick={() => {
                    setPageSize(10);
                    setCurrentPage(1);
                    setShow(item?.id);
                  }}
                  className="flex flex-col items-center gap-3 cursor-pointer"
                >
                  <div className="gap-2 px-4 flex items-center">
                    <p
                      className={`p1-medium whitespace-nowrap  capitalize text-${colors?.[item?.status]
                        }-${item?.status == "active" ? "400" : "700"} `}
                    >
                      {item?.subTitle ?? item?.title}
                    </p>
                    <p
                      className={`text-button-medium ml-2 rounded-lg border border-${colors?.[item?.status]
                        }-50 bg-${colors?.[item?.status]}-50 px-2 py-1 text-${colors?.[item?.status]
                        }-400 group-focus-visible:border-${colors?.[item?.status]
                        }-200`}
                    >
                      {item?.value?.length > 99 ? "99+" : item?.value?.length}
                    </p>
                  </div>
                  {item?.status == "active" && (
                    <div
                      className={`flex h-1 w-full rounded-tl-xl rounded-tr-xl bg-${colors?.[item?.status]
                        }-400`}
                    />
                  )}
                </div>
              );
            }}
          />

          <div className="gap-6 overflow-hidden overflow-x-scroll">
            <table className="table-auto w-full ">
              <thead>
                <tr>
                  {headList?.map((item, index) => (
                    <th
                      key={index}
                      // className={twMerge("p-4", index === 0 ? "w-32" : " w-32")}
                      className={twMerge(
                        "py-4 border-b-[1px] border-t-[1px] border-greyscaleGON-200"
                      )}
                    >
                      <div className="flex items-center gap-2 justify-between">
                        <p className="capitalize text-start p2-medium text-greyscaleGON-700 max-w-full whitespace-nowrap overflow-hidden text-ellipsis">
                          {item}
                        </p>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="flex-row xs:flex-row-reverse">
                {currentTableData?.map((item, index) => {
                  const status = item?.status;
                  const typePayment = item?.type_payment;
                  const isMarketplace =
                    (item?.resi_market_place !== undefined &&
                      item?.resi_market_place !== null &&
                      item?.resi_market_place !== "") ||
                    (item?.kurir_resi_marketplace !== undefined &&
                      item?.kurir_resi_marketplace !== null &&
                      item?.kurir_resi_marketplace !== "");

                  const allow = status ? status == "booking" : true;
                  const isAllow = item?.is_transfer
                    ? item?.mitra_id == session?.user?.data?.mitra_id &&
                    status == "booking"
                    : allow;

                  let timeOrder = item?.created_at_costume;
                  let statusNewOrder =
                    new Date() - new Date(timeOrder) <= 10 * 60 * 1000;
                  let styleNewOrder =
                    status == "booking" && statusNewOrder
                      ? "bg-successGON-50"
                      : "";
                  return (
                    <tr key={index}>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <div className="flex gap-4 items-center">
                          {loading.process?.[item?.code_order] ? (
                            <div className="animate-spin text-primaryGON-400">
                              <LoadingSvg className="w-8 h-8" />
                            </div>
                          ) : item?.is_transfer ||
                            session?.user?.data?.mitra_level == 1 ? (
                            <div>
                              {!item?.is_transfer ? (
                                <div
                                  onClick={() => {
                                    !isAllow ||
                                      loading.cancel?.[item?.code_order]
                                      ? {}
                                      : handleChangeStatusOrder(
                                        item,
                                        status == "booking"
                                          ? "process"
                                          : "completed"
                                      );
                                  }}
                                  className={
                                    isAllow
                                      ? "cursor-pointer"
                                      : "cursor-not-allowed"
                                  }
                                >
                                  <AcceptSvg
                                    className={twMerge(
                                      isAllow &&
                                        !loading.cancel?.[item?.code_order]
                                        ? "text-successGON-500"
                                        : "text-greyscaleGON-200",
                                      "h-6 w-6 xs:h-8 xs:w-8"
                                    )}
                                  />
                                </div>
                              ) : (
                                <>
                                  <div
                                    onClick={() => {
                                      if (loading.cancel?.[item?.code_order])
                                        return;

                                      if (
                                        !item?.payment_url ||
                                        status == "booking"
                                      ) {
                                        !isAllow
                                          ? {}
                                          : handlePaymentOnline(item);
                                      }
                                    }}
                                    className={twMerge(
                                      (
                                        !item?.payment_url ||
                                          status == "booking"
                                          ? !isAllow ||
                                          loading.cancel?.[item?.code_order]
                                          : true
                                      )
                                        ? "cursor-not-allowed"
                                        : "cursor-pointer",
                                      "items-center flex justify-center h-full text-center"
                                    )}
                                  >
                                    {!item?.payment_url ||
                                      status == "booking" ? (
                                      <div className="relative group">
                                        <GiveMoneySvg
                                          className={twMerge(
                                            !isAllow ||
                                              loading.cancel?.[item?.code_order]
                                              ? "text-greyscaleGON-200"
                                              : "text-secondaryGON-400",
                                            "h-6 w-6 xs:h-8 xs:w-8"
                                          )}
                                        />
                                        {!isAllow ||
                                          loading.cancel?.[
                                          item?.code_order
                                          ] ? null : (
                                          <div className="group-hover:visible group-hover:opacity-100 invisible opacity-10 transition-all">
                                            <span
                                              className={twMerge(
                                                "absolute inline-block bg-neutral-500 text-white rounded-md",
                                                "left-1/2 -translate-x-1/2 bottom-[calc(100%+5px)]",
                                                "z-50",
                                                "whitespace-nowrap capitalize p3-medium text-shadesGON-50 px-2 py-1"
                                              )}
                                            >
                                              Bayar Sekarang
                                            </span>
                                            <span className="absolute inline-block border-[8px] left-1/2 -translate-x-1/2 bottom-full border-l-transparent border-r-transparent border-b-0 border-t-neutral-500" />
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          "invisible h-6 w-6 xs:h-8 xs:w-8"
                                        }
                                      />
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ) : (
                            <div
                              className={"invisible h-6 w-6 xs:h-8 xs:w-8"}
                            />
                          )}
                          {loading.cancel?.[item?.code_order] ? (
                            <div className="animate-spin text-primaryGON-400">
                              <LoadingSvg className="w-8 h-8" />
                            </div>
                          ) : (
                            <div
                              onClick={() =>
                                !isAllow || loading.process?.[item?.code_order]
                                  ? {}
                                  : handleChangeStatusOrder(item, "cancel")
                              }
                              className={twMerge(
                                isAllow
                                  ? "cursor-pointer"
                                  : "cursor-not-allowed",
                                "relative group"
                              )}
                            >
                              <RemoveSvg
                                className={twMerge(
                                  isAllow &&
                                    !loading.process?.[item?.code_order]
                                    ? "text-errorGON-500"
                                    : "text-greyscaleGON-200",
                                  "h-6 w-6 xs:h-7 xs:w-7"
                                )}
                              />
                              {isAllow &&
                                !loading.process?.[item?.code_order] && (
                                  <div className="group-hover:visible group-hover:opacity-100 invisible opacity-10 transition-all">
                                    <span
                                      className={twMerge(
                                        "absolute inline-block bg-neutral-500 text-white rounded-md",
                                        "left-1/2 -translate-x-1/2 bottom-[calc(100%+5px)]",
                                        "z-50",
                                        "whitespace-nowrap capitalize p3-medium text-shadesGON-50 px-2 py-1"
                                      )}
                                    >
                                      Batalkan
                                    </span>
                                    <span className="absolute inline-block border-[8px] left-1/2 -translate-x-1/2 bottom-full border-l-transparent border-r-transparent border-b-0 border-t-neutral-500" />
                                  </div>
                                )}
                            </div>
                          )}
                          <div
                            onClick={() =>
                              runGetDetailOrder({ ...item, isAllow, status })
                            }
                            className={twMerge("cursor-pointer relative group")}
                          >
                            <EyeOnSvg
                              className={twMerge(
                                "text-primaryGON-400 h-6 w-6 xs:h-7 xs:w-7"
                              )}
                            />
                            <div className="group-hover:visible group-hover:opacity-100 invisible opacity-10 transition-all">
                              <span
                                className={twMerge(
                                  "absolute inline-block bg-neutral-500 text-white rounded-md",
                                  "left-1/2 -translate-x-1/2 bottom-[calc(100%+5px)]",
                                  "z-50",
                                  "whitespace-nowrap capitalize p3-medium text-shadesGON-50 px-2 py-1"
                                )}
                              >
                                Detail
                              </span>
                              <span className="absolute inline-block border-[8px] left-1/2 -translate-x-1/2 bottom-full border-l-transparent border-r-transparent border-b-0 border-t-neutral-500" />
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <div className="max-w-[100px]">
                          <Label
                            classNameText={
                              "max-w-full whitespace-nowrap overflow-hidden text-ellipsis"
                            }
                            className={"justify-center"}
                            title={title?.[status] ?? status}
                            colors={colors?.[status] ?? "greyscale"}
                            univColor
                          />
                        </div>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <div className="max-w-[100px]">
                          <Label
                            classNameText={
                              "max-w-full whitespace-nowrap overflow-hidden text-ellipsis"
                            }
                            className={"justify-center"}
                            title={title?.[typePayment] ?? typePayment}
                            colors={colors?.[typePayment] ?? "danger"}
                          />
                        </div>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <div
                          onClick={() =>
                            runGetDetailOrder({ ...item, isAllow, status })
                          }
                          className="cursor-pointer"
                        >
                          <p className="whitespace-nowrap p1-regular text-primaryGON-400">
                            {item?.code_order}
                          </p>
                        </div>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <p className="max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700">
                          {item?.created_at}
                        </p>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <p className="max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700">
                          {item?.name_buyyer || item?.name_recipient}
                        </p>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <p className="max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700">
                          {item?.name_recipient}
                        </p>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <p className="max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700">
                          {!item?.buyyer_info
                            ? "-"
                            : item?.buyyer_info == "agent"
                              ? "agen"
                              : item?.buyyer_info}
                        </p>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <p className="max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-greyscaleGON-700">
                          {currency(item?.total_pembayaran)}
                        </p>
                      </td>
                      <td className={twMerge("py-2 pr-4", styleNewOrder)}>
                        <div
                          disable={
                            !item?.resi_ekspedition ||
                            item?.resi_ekspedition === "-"
                          }
                          onClick={() => {
                            runGetDetailOrder({ ...item, isAllow, status });
                            runLacak({
                              otherItem: item
                            });
                          }}
                          className={twMerge(
                            "flex flex-col uppercase",
                            !item?.resi_ekspedition ||
                              item?.resi_ekspedition === "-"
                              ? ""
                              : "cursor-pointer"
                          )}
                        >
                          <p className="max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p1-regular text-primaryGON-400">
                            {item?.resi_ekspedition ?? "-"}
                          </p>
                          {/* <p className='max-w-full whitespace-nowrap overflow-hidden text-ellipsis capitalize p3-medium text-greyscaleGON-400'>
                          {item?.kurir?.provider} - {item?.kurir?.layanan}
                        </p> */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              {(loading?.firstGetDatas || currentTableData?.length <= 0) && (
                <tfoot>
                  <tr>
                    <td colSpan={9} className="text-center items-center pt-4">
                      <p className="select-none capitalize p2-regular text-center text-greyscaleGON-700">
                        {loading?.firstGetDatas ? (
                          <p>Loading...</p>
                        ) : (
                          <p>Not Found</p>
                        )}
                      </p>
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
            <FooterTable
              currentPage={currentPage}
              totalCount={
                datas?.filter((item) =>
                  showFilter?.value
                    ? item?.buyyer_info?.toLowerCase() ==
                    showFilter?.value?.toLowerCase()
                    : item
                )?.length
              }
              pageSize={pageSize}
              setPageSize={setPageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>

        <ContainerModal
          className={twMerge(
            "xs:p-8 p-4 min-h-screen h-full",
            showModal?.type == "payment-online" ? "max-w-[552px]" : "",
            showModal?.type == "tracking-resi" ? "max-w-[600px]" : ""
          )}
        >
          <div className="flex flex-col xs:gap-10 gap-5">
            {showModal?.type == "tracking-resi" ? (
              <div className="flex flex-col gap-4">
                <div className="flex flex-row items-start justify-between">
                  <div className="flex flex-col gap-1">
                    <p className="h6-medium text-greyscaleGON-700">
                      Lacak Paket
                    </p>
                    <Label
                      size="small"
                      univColor
                      title={
                        title?.[datasModals?.status] ?? datasModals?.status
                      }
                      colors={colors?.[datasModals?.status] ?? "greyscale"}
                      className={"w-fit"}
                    />
                  </div>
                  <div
                    className="cursor-pointer justify-end"
                    onClick={() => {
                      setShowModal((old) => ({
                        ...old,
                        type: "detail-order"
                      }));
                    }}
                  >
                    <RemoveSvg className="h-6 w-6 xs:h-8 xs:w-8 text-greyscaleGON-700" />
                  </div>
                </div>
                <Divider />
                {showModal?.listTracking?.length <= 0 ? (
                  <div className="py-5">
                    <p className="p2-regular text-greyscaleGON-400 text-center">
                      Data tidak ditemukan
                    </p>
                  </div>
                ) : (
                  <>
                    <div className="flex flex-col gap-1">
                      <div className="flex gap-2 items-center flex-row">
                        <p className="p1-medium text-greyscaleGON-700">
                          {datasModals?.code_order}
                        </p>
                        <button
                          onClick={() => {
                            navigator.clipboard.writeText(
                              datasModals?.code_order
                            );
                            toast.success(
                              "Success copy code order!",
                              settingToast
                            );
                          }}
                          className="text-primaryGON-400"
                        >
                          <CopySvg />
                        </button>
                      </div>
                      <p className="p2-regular text-greyscaleGON-400">
                        {datasModals?.resi} - {datasModals?.kurir?.provider}
                      </p>
                    </div>
                    <div className="flex max-h-[30rem] overflow-hidden overflow-y-scroll  flex-col border px-6 py-4 gap-8 rounded-md border-greyscaleGON-200 h-full">
                      <div className="flex flex-col gap-8 relative border-l-4">
                        {showModal?.listTracking?.map((item, index) => (
                          <div key={index} className="flex">
                            <div className="bg-shadesGON-50 w-fit h-fit p-1 rounded-full absolute -left-3">
                              <div className="w-4 h-4 rounded-full bg-primaryGON-400"></div>
                            </div>
                            <div className="pl-4 flex flex-col gap-2">
                              <p className="p2-regular text-greyscaleGON-400">
                                {item?.date}
                                {/* {format(new Date(item?.date), "dd MM yyyy pp")} */}
                              </p>
                              <p className="p2-semibold text-greyscaleGON-700">
                                {item?.code}
                              </p>
                              <p className="p2-regular text-greyscaleGON-400">
                                {item?.desc}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ) : showModal?.type == "payment-online" ? (
              <>
                <PaymentCard
                  handleClose={() => {
                    closeModal();
                    setChooseBank({});
                    setAllowChangeAddress(false);
                  }}
                  chooseBank={chooseBank}
                  setChooseBank={setChooseBank}
                  mitra_id={datasModals?.mitra_id}
                  order_id={datasModals?.order_id}
                  session={session}
                />
              </>
            ) : (
              <>
                <div className="flex justify-between items-center">
                  <p className="subheading-semiBold text-greyscaleGON-700">
                    Detail Laporan Belanja{" "}
                  </p>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      closeModal();
                      setAllowChangeAddress(false);
                      setShowAllOrder(false);
                    }}
                  >
                    <RemoveSvg className="h-6 w-6 sm:h-8 sm:w-8 text-greyscaleGON-700" />
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-2">
                  <p className="sm:h4-semiBold h6-semiBold text-primaryGON-400 max-w-full whitespace-nowrap overflow-hidden text-ellipsis">
                    #{datasModals?.code_order}
                  </p>
                  <div className="flex flex-col gap-2 justify-end">
                    <p className="sm:p1-regular p3-regular text-greyscaleGON-400 sm:text-end">
                      Tanggal Transaksi
                    </p>
                    <p className="sm:p1-medium p3-medium text-greyscaleGON-700 sm:text-end">
                      {!datasModals?.tanggal_checkout
                        ? datasModals?.tanggal_checkout
                        : format(
                          new Date(datasModals?.tanggal_checkout),
                          "dd MMMM yyyy"
                        )}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row gap-4 w-full">
                  {/* Daftar Belanja */}
                  <div
                    ref={refScreenshot}
                    className={twMerge(
                      "w-full h-fit flex flex-col sm:gap-8 sm:p-8 p-4 gap-4 border border-greyscaleGON-200 rounded-2xl relative",
                      allowChangeAddress ? "opacity-20 pointer-events-none" : ""
                    )}
                  >
                    <div
                      className="absolute right-0 top-0 border-b border-l cursor-pointer rounded-bl-lg"
                      onClick={() => {
                        getImage();
                      }}
                    >
                      <div className="p-2">
                        <ImageSvg className="w-3 h-3 text-greyscaleGON-400" />
                      </div>
                    </div>
                    <div className="flex sm:flex-row flex-col justify-between sm:items-center">
                      <p className="subheading-semiBold text-greyscaleGON-400">
                        Daftar Belanja
                      </p>
                      <p
                        className={twMerge(
                          "p3-regular  cursor-pointer",
                          datasModals?.products?.reverse()?.length <= 3
                            ? "text-greyscaleGON-400"
                            : "text-primaryGON-400 hover:underline"
                        )}
                        onClick={() =>
                          datasModals?.products?.reverse()?.length > 3 &&
                          setShowAllOrder(!showAllOrder)
                        }
                      >
                        {datasModals?.products?.reverse()?.length <= 3
                          ? ""
                          : !showAllOrder
                            ? "Tampilkan Semua"
                            : "Ciutkan"}
                      </p>
                    </div>
                    <div
                      className={twMerge(
                        "flex flex-col gap-4",
                        !showAllOrder
                          ? "max-h-96 overflow-hidden overflow-y-scroll"
                          : ""
                      )}
                    >
                      {datasModals?.products?.map((item, index) => (
                        <div
                          key={index}
                          className="flex sm:flex-row flex-col gap-2 sm:justify-between sm:items-end"
                        >
                          <div className="flex flex-col gap-2">
                            <div className="flex sm:flex-row flex-col sm:items-center gap-2">
                              <p className="p1-semiBold text-primaryGON-400 ">
                                {item?.name_product} : {item?.color},{" "}
                                {item?.size}
                              </p>
                              <Label
                                classNameText={
                                  "max-w-full whitespace-nowrap overflow-hidden text-ellipsis"
                                }
                                size="small"
                                title={item?.brand}
                                colors="greyscale"
                                className={"w-fit"}
                              />
                            </div>
                            <div className="flex sm:flex-row flex-col-reverse sm:items-center items-start gap-2">
                              <div className="flex items-center gap-2">
                                <p className="p1-regular text-greyscaleGON-700">
                                  {item?.qty}
                                </p>
                                <p className="p1-regular text-greyscaleGON-700">
                                  x
                                </p>
                                <p className="p1-regular text-greyscaleGON-700">
                                  {currency(
                                    (item?.diskon_presentase || 0) > 0
                                      ? ((100 -
                                        (item?.diskon_presentase || 0)) /
                                        100) *
                                      item?.price_tags
                                      : item?.price_tags -
                                        (item?.diskon_nominal || 0) >
                                        0
                                        ? item?.price_tags -
                                        (item?.diskon_nominal || 0)
                                        : 0
                                  )}
                                </p>
                              </div>
                              {((item?.diskon_presentase || 0) > 0 ||
                                (item?.diskon_nominal || 0) > 0) && (
                                  <>
                                    <p className="p1-regular text-greyscaleGON-400 line-through">
                                      {currency(item?.price_tags)}
                                    </p>
                                    {(item?.diskon_presentase || 0) > 0 && (
                                      <Label
                                        size="small"
                                        title={`${item?.diskon_presentase || 0
                                          } %`}
                                        colors="secondary"
                                      />
                                    )}
                                  </>
                                )}
                            </div>
                          </div>
                          <p className="p1-semiBold text-greyscaleGON-700">
                            {currency(
                              (item?.diskon_presentase || 0) > 0
                                ? ((100 - (item?.diskon_presentase || 0)) /
                                  100) *
                                item?.price_tags *
                                item?.qty
                                : (item?.price_tags -
                                  (item?.diskon_nominal || 0)) *
                                item?.qty
                            )}
                          </p>
                        </div>
                      ))}
                    </div>
                    <Divider />
                    <div className="flex flex-col gap-4">
                      <div className="flex flex-col sm:gap-2 gap-3">
                        {/* Sub Harga Produk */}
                        <div className="flex sm:flex-row sm:justify-between sm:items-center flex-col items-start gap-1">
                          <p className="p1-regular text-greyscaleGON-400">
                            Sub Harga Produk
                          </p>
                          <p className="p1-regular text-greyscaleGON-700">
                            {currency(datasModals?.total_harga_normal)}
                          </p>
                        </div>

                        {/* Total Diskon */}
                        <div className="flex sm:flex-row sm:justify-between sm:items-center flex-col items-start gap-1 ">
                          <p className="p1-regular text-greyscaleGON-400">
                            Total Diskon
                          </p>
                          <p className="p1-regular text-errorGON-400">
                            -{" "}
                            {currency(
                              datasModals?.total_diskon_presentase +
                              datasModals?.total_diskon_nominal
                            )}
                          </p>
                        </div>

                        {/* total_voucher */}
                        <div className="flex sm:flex-row sm:justify-between sm:items-center flex-col items-start gap-1 ">
                          <p className="p1-regular text-greyscaleGON-400">
                            Total Voucher
                          </p>
                          <p className="p1-regular text-errorGON-400">
                            -{currency(datasModals?.total_voucher)}
                          </p>
                        </div>

                        {/* fee_admin */}
                        <div className="flex sm:flex-row sm:justify-between sm:items-center flex-col items-start gap-1 ">
                          <p className="p1-regular text-greyscaleGON-400">
                            Biaya Admin
                          </p>
                          <p className="p1-regular text-greyscaleGON-700">
                            {currency(datasModals?.admin_fee)}
                          </p>
                        </div>

                        {/* Sub Total Produk */}
                        <div className="flex sm:flex-row sm:justify-between sm:items-center flex-col items-start gap-1 ">
                          <p className="p1-regular text-greyscaleGON-400">
                            Sub Total Produk
                          </p>
                          <p className="p1-semiBold text-greyscaleGON-700">
                            {currency(
                              datasModals?.total_pembayaran -
                              datasModals?.biaya_pengiriman
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col sm:gap-2 gap-3">
                        {/* Biaya Pengiriman */}
                        <div className="flex sm:flex-row sm:justify-between sm:items-center flex-col items-start gap-1 ">
                          <p className="p1-regular text-greyscaleGON-400">
                            Biaya Pengiriman ({datasModals?.total_weight ?? "0"}{" "}
                            gr)
                          </p>
                          <p className="p1-regular text-greyscaleGON-700">
                            {currency(datasModals?.biaya_pengiriman)}
                          </p>
                        </div>

                        {/* Biaya Pengiriman */}
                        <div className="flex flex-col gap-2">
                          <p className="p1-regular text-greyscaleGON-400">
                            {datasModals?.kurir?.provider}{" "}
                            {datasModals?.kurir?.layanan}
                          </p>
                          <div className="flex sm:flex-row flex-col sm:items-center items-start gap-1">
                            <Label
                              title={datasModals?.resi}
                              colors="greyscale"
                              size="small"
                            />
                            <Button
                              label="Lacak"
                              variants="text"
                              size="small"
                              disable={
                                !datasModals?.otherItem?.order_id ||
                                !datasModals?.resi ||
                                datasModals?.resi === "-"
                              }
                              onClick={() => runLacak(datasModals)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* total order */}
                    <div className="flex sm:flex-row sm:justify-between sm:items-center flex-col items-start gap-1 ">
                      <p className="p1-regular text-greyscaleGON-400">
                        Total Order
                      </p>
                      <p className="h6-medium text-successGON-400">
                        {currency(datasModals?.total_pembayaran)}
                      </p>
                    </div>

                    <div>
                      <Button
                        label={
                          datasModals?.otherItem?.is_transfer
                            ? "Bayar Sekarang"
                            : session?.user?.data?.mitra_level !== 1
                              ? "Menunggu orderan diproses"
                              : datasModals?.otherItem?.status == "received" ||
                                datasModals?.otherItem?.status == "on-delivery"
                                ? "Terima Orderan"
                                : "Proses Orderan"
                        }
                        disable={
                          !datasModals?.otherItem?.isAllow ||
                          loading.process?.[
                          datasModals?.otherItem?.code_order
                          ] ||
                          loading.cancel?.[
                          datasModals?.otherItem?.code_order
                          ] ||
                          (session?.user?.data?.mitra_level !== 1 &&
                            !datasModals?.otherItem?.is_transfer)
                        }
                        loading={
                          loading.process?.[
                          datasModals?.otherItem?.code_order
                          ] ||
                          loading.cancel?.[datasModals?.otherItem?.code_order]
                        }
                        onClick={async () => {
                          if (datasModals?.otherItem?.is_transfer) {
                            if (
                              !datasModals?.otherItem?.payment_url ||
                              datasModals?.otherItem?.status == "booking"
                            ) {
                              handlePaymentOnline(datasModals?.otherItem);
                            } else {
                              if (
                                datasModals?.otherItem?.status == "completed" ||
                                datasModals?.otherItem?.mitra_id !==
                                session?.user?.data?.mitra_id
                              )
                                return;
                              window.location.href =
                                datasModals?.otherItem?.payment_url;
                            }
                          } else {
                            if (session?.user?.data?.mitra_level !== 1) null;
                            else
                              await handleChangeStatusOrder(
                                datasModals?.otherItem,
                                datasModals?.otherItem?.status == "booking"
                                  ? "process"
                                  : "completed"
                              );
                          }
                        }}
                        variants="outline"
                      />

                      {isMarketplace && (
                        <div className="mt-3 flex flex-col gap-2">
                          <Button
                            label="Upload Resi Marketplace"
                            className="w-full flex justify-center items-center gap-2"
                            variants="outline"
                            icon={{ left: (props) => <Upload {...props} /> }}
                            onClick={() => {
                              setActiveUploadOrderId(datasModals?.order_id);
                              setTimeout(() => fileInputRef.current?.click(), 50);
                            }}
                          />
                          {datasModals?.expired_url && (
                            <Button
                              label="Lihat Resi Marketplace"
                              className="w-full flex justify-center items-center gap-2"
                              variants="outline"
                              colors="success"
                              onClick={() => window.open(datasModals?.expired_url, "_blank")}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Status Order */}
                  <div
                    className="w-full flex flex-col sm:gap-8 sm:p-8 p-4 gap-4
            border border-greyscaleGON-200 rounded-2xl
            "
                  >
                    {allowChangeAddress ? (
                      <FormChangeAddress
                        loading={loading}
                        setLoading={setLoading}
                        runGetListOrder={runGetListOrder}
                        closeModal={closeModal}
                        datasModals={datasModals}
                        session={session}
                        profile={profile}
                        setAllowChangeAddress={setAllowChangeAddress}
                      />
                    ) : (
                      <>
                        {/* Status Order */}
                        <p className="subheading-semiBold text-greyscaleGON-400">
                          Status Order
                        </p>
                        {/* <div className="flex flex-col gap-2">
                          {datasModals?.history_status_date?.map(
                            (item, index) => {
                              let date = new Date(item?.status_date);
                              date = !isNaN(date) ? date : new Date();
                              const formattedDate = format(date, "yyyy-MM-dd");
                              const time = format(date, "pp");

                              return (
                                <div
                                  key={index}
                                  className="flex flex-row sm:gap-5 gap-2"
                                >
                                  <div className="flex sm:flex-row flex-col sm:gap-5 w-fit">
                                    <p className="p1-semiBold text-greyscaleGON-700">
                                      {formattedDate}
                                    </p>
                                    <p className="p1-semiBold text-greyscaleGON-700">
                                      {time}
                                    </p>
                                  </div>
                                  <Label
                                    classNameText={"uppercase"}
                                    title={title?.[item?.status]}
                                    colors={colors?.[item?.status]}
                                    univColor
                                    size="small"
                                    className={"flex"}
                                  />
                                </div>
                              );
                            }
                          )}
                        </div> */}
                        <div className="flex flex-col gap-2">
                          {datasModals?.history_status_date?.map((item, index) => {
                            const rawStatusDate = item?.status_date;

                            return (
                              <div
                                key={index}
                                className="flex flex-row sm:gap-5 gap-2"
                              >
                                <div className="flex sm:flex-row flex-col sm:gap-5 w-fit">
                                  <p className="p1-semiBold text-greyscaleGON-700">
                                    {rawStatusDate}
                                  </p>
                                  {/* <p className="p1-semiBold text-greyscaleGON-700">
                                      {time}
                                    </p> */}
                                </div>
                                <Label
                                  classNameText={"uppercase"}
                                  title={title?.[item?.status]}
                                  colors={colors?.[item?.status]}
                                  univColor
                                  size="small"
                                  className={"flex"}
                                />
                              </div>
                            );
                          }
                          )}
                        </div>
                        <Divider />

                        {datasModals.status == "canceled" && (
                          <>
                            {/* Alasan Dibatalkan */}
                            <p className="subheading-semiBold text-greyscaleGON-400">
                              Alasan Dibatalkan
                            </p>
                            <div className="bg-greyscaleGON-50 p-4">
                              <p>{datasModals?.message_cancel_admin || "-"}</p>
                            </div>
                            <Divider />
                          </>
                        )}

                        {/* Catatan */}
                        <p className="subheading-semiBold text-greyscaleGON-400">
                          Catatan
                        </p>
                        <div className="bg-greyscaleGON-50 p-4">
                          <p>{datasModals?.catatan || "-"}</p>
                        </div>
                        <Divider />
                        {/* Dropship */}
                        <p className="subheading-semiBold text-greyscaleGON-400">
                          Dropship
                        </p>
                        <div className="flex flex-col gap-1">
                          <p className="p1-semiBold text-greyscaleGON-700 capitalize">
                            {datasModals?.addres_drops?.sander_name}
                          </p>
                          <p className="p1-regular text-greyscaleGON-700">
                            {datasModals?.addres_drops?.sander_telephon}
                          </p>
                        </div>
                        <Divider />

                        {/* Alamat Penerima */}
                        <div className="flex  items-center gap-4 justify-between">
                          <p className="subheading-semiBold text-greyscaleGON-400">
                            Alamat Penerima
                          </p>
                          <div>
                            <Button
                              label="ubah"
                              variants="outline"
                              size="small"
                              disable={
                                session?.user?.data?.mitra_level > 3 ||
                                  datasModals?.otherItem?.type_payment ==
                                  "payment_gateway" ||
                                  datasModals?.status !== "booking" ||
                                  !datasModals?.code_order
                                  ? true
                                  : false
                              }
                              onClick={() => setAllowChangeAddress(true)}
                            />
                          </div>
                        </div>
                        <div className="flex flex-col gap-1">
                          <p className="p1-semiBold text-greyscaleGON-700 capitalize">
                            {datasModals?.addres_recipient?.recipient_name}
                          </p>
                          {!datasModals?.addres_recipient?.address ||
                            datasModals?.addres_recipient?.address ==
                            "-" ? null : (
                            <p className="p1-regular text-greyscaleGON-700">
                              {datasModals?.addres_recipient?.address}, Kel.{" "}
                              {datasModals?.addres_recipient?.subdistrict_name},
                              Kec.{" "}
                              {datasModals?.addres_recipient?.district_name},{" "}
                              {datasModals?.addres_recipient?.city_name},{" "}
                              {datasModals?.addres_recipient?.province_name}{" "}
                              {datasModals?.addres_recipient?.postal_code}
                            </p>
                          )}
                          <p className="p1-regular text-greyscaleGON-700">
                            {datasModals?.addres_recipient?.recipient_telephon}
                          </p>
                        </div>
                        <Divider />

                        {/* No Resi */}
                        <p className="subheading-semiBold text-greyscaleGON-400">
                          {datasModals?.status_resi_cod
                            ? "Cash On Delivery"
                            : datasModals?.status_resi_gon
                              ? "No Resi Gon"
                              : datasModals?.status_resi_marketplace
                                ? "No Resi Marketplace"
                                : "not found"}
                        </p>
                        <div className="flex flex-col gap-1">
                          <p className="p1-semiBold text-greyscaleGON-700 capitalize">
                            {datasModals?.status_resi_marketplace
                              ? datasModals?.resi_marketplace
                              : datasModals?.resi}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </ContainerModal>
        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          accept="image/*,application/pdf"
          onChange={handleUploadResi}
        />
      </div>
    )
  );
}

const FormChangeAddress = ({
  session,
  profile,
  setLoading,
  runGetListOrder,
  closeModal,
  loading,
  datasModals,
  setAllowChangeAddress
}) => {
  const events = datasModals?.status_resi_cod
    ? "cod"
    : datasModals?.status_resi_gon
      ? "resi_gon"
      : datasModals?.status_resi_marketplace
        ? "resi_marketplace"
        : "not found";

  const [forms, setForms] = useState({
    recipments_name: datasModals?.addres_recipient?.recipient_name,
    recipments_email: "",
    recipments_telphone: datasModals?.addres_recipient?.recipient_telephon,
    recipments_address: "",
    sender_name: datasModals?.addres_drops?.sander_name,
    sender_telphone: datasModals?.addres_drops?.sander_telephon,
    pengiriman: {
      noResi: "",
      chooseKurir: {
        empty: true
      }
    }
  });
  const [listAvailableShipping, setListAvailableShipping] = useState();
  const [shippingAvailableGet, setShippingAvailableGet] = useState([
    "RAJA_ONGKIR"
  ]);
  const [listEkspedisi, setListEkspedisi] = useState([]);
  const [listShippingMarketplace, setListShippingMarketplace] = useState([]);
  const [isIdArea, setIsIdArea] = useState("");
  const [metodePengiriman, setIsMetodePengiriman] = useState({});
  const [metodePengirimanResi, setIsMetodePengirimanResi] = useState({
    value: events
  });

  const [errors, setErrors] = useState({});
  const [area, setArea] = useState({
    province: [],
    city: [],
    district: [],
    sub_district: []
  });
  const [showDropdown, setShowDropdown] = useState({
    key: false
  });

  const handleChange = (name) => (value) => {
    if (
      (name == "sender_telphone" || name == "recipments_telphone") &&
      (value.startsWith("0") || value.startsWith("62"))
    ) {
      value = "+62" + value.slice(2);
    }

    setForms((form) => ({
      ...form,
      [name]: value
    }));
  };

  const handleChangeError = (name) => (value) => {
    setErrors((error) => ({
      // ...error,
      [name]: value
    }));
  };

  function handleDropdown(state) {
    setShowDropdown((old) => ({ ...old, [state]: !showDropdown?.[state] }));
  }

  useEffect(() => {
    run();
  }, [
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan
  ]);

  async function getListAvailableShipping() {
    setLoading((old) => ({ ...old, getListAvailableShipping: true }));
    try {
      const datas = await fetchAPI({
        uri: "shipping/list",
        method: "GET",
        token: session?.user?.token
      });
      if (!datas?.error) {
        return setListAvailableShipping(datas.data);
      }
      throw new Error(datas?.error);
    } catch (error) {
      console.log(`error get list available shipping : ${error?.message}`);
    } finally {
      setLoading((old) => ({ ...old, getListAvailableShipping: false }));
    }
  }

  useEffect(() => {
    if (!listAvailableShipping && session?.user?.token)
      getListAvailableShipping();
  }, [session?.user?.token]);

  const run = useCallback(async () => {
    try {
      const payload = {
        province: forms?.alamat?.provinsi?.id,
        city: forms?.alamat?.kabupaten,
        district: forms?.alamat?.kecamatan
      };
      !forms?.alamat?.provinsi?.id && delete payload?.province;
      !forms?.alamat?.kabupaten && delete payload?.city;
      !forms?.alamat?.kecamatan && delete payload?.district;

      const data_area = await getGroupArea(payload);
      const thisvalue =
        area?.province?.length <= 0
          ? "province"
          : area?.city?.length <= 0
            ? "city"
            : area?.district?.length <= 0
              ? "district"
              : "sub_district";
      setArea((old) => ({ ...old, [thisvalue]: data_area }));
    } catch (error) {
      console.log(error.message);
    }
  }, [
    area,
    forms?.alamat?.provinsi,
    forms?.alamat?.kabupaten,
    forms?.alamat?.kecamatan
  ]);

  const filterTextArea = {
    province: forms?.alamat?.provinsi?.title,
    city: forms?.alamat?.kabupaten,
    district: forms?.alamat?.kecamatan,
    sub_district: forms?.alamat?.kelurahan?.title
  };

  const newArea = (params) =>
    area?.[params]?.map((item, index) => ({
      id: item?.province_id
        ? item?.province_id
        : item?.area_id
          ? item?.area_id
          : index,
      title: item?.province_name
        ? item?.province_name
        : item?.city_name
          ? item?.city_name
          : item?.district_name
            ? item?.district_name
            : item?.subdistrict_name,
      ...(params == "sub_district" ? { other_field: item } : {})
    }));

  const isArea = (params) => {
    return newArea(params)
      ?.sort((a, b) => a?.title?.localeCompare(b?.title))
      .filter((item) =>
        !filterTextArea?.[params]
          ? item
          : item?.title
            .toLowerCase()
            ?.includes(filterTextArea?.[params]?.toLowerCase())
      );
  };

  const listFormDataPengirim = [
    {
      key: "sender_name",
      fieldDB: "sender_name",
      placeholder: "Masukkan nama lengkap pengirim",
      label: "Nama Pengirim",
      typeInput: "text"
    },
    {
      key: "sender_telphone",
      fieldDB: "sender_telphone",
      placeholder: "+62xxxxxxxxxxx",
      label: "No. Telp",
      typeInput: "text"
    }
  ];

  const listFormDataPenerima = [
    {
      key: "recipments_name",
      fieldDB: "recipments_name",
      placeholder: "Masukkan nama lengkap penerima",
      label: "Nama Penerima",
      typeInput: "text"
    },
    {
      key: "recipments_email",
      fieldDB: "recipments_email",
      placeholder: "Masukkan email penerima",
      label: "Email (Opsional)",
      typeInput: "text"
    },
    {
      key: "recipments_telphone",
      fieldDB: "recipments_telphone",
      placeholder: "+62xxxxxxxxxxx",
      label: "No. Telp",
      typeInput: "text"
    }
  ];

  const listFormAlamatPenerima = [
    {
      key: "provinsi",
      keyArea: "province",
      placeholder: "Pilih Provinsi",
      label: "Provinsi",
      valueDropdown: forms?.alamat?.provinsi?.title,
      zIndex: 5,
      defaultState: {
        id: 0,
        title: ""
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props
        };
      },
      alamatFieldKosong: {
        kabupaten: "",
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: ""
        }
      },
      areaFieldKosong: {
        city: [],
        district: [],
        sub_district: []
      }
    },
    {
      key: "kabupaten",
      keyArea: "city",
      disabled: !forms?.alamat?.provinsi,
      placeholder: "Pilih Kabupaten",
      label: "Kabupaten",
      valueDropdown: forms?.alamat?.kabupaten,
      zIndex: 4,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kecamatan: "",
        kelurahan: {
          id: 0,
          title: ""
        }
      },
      areaFieldKosong: {
        district: [],
        sub_district: []
      }
    },
    {
      key: "kecamatan",
      keyArea: "district",
      disabled: !forms?.alamat?.kabupaten,
      placeholder: "Pilih Kecamatan",
      label: "Kecamatan",
      valueDropdown: forms?.alamat?.kecamatan,
      zIndex: 3,
      defaultState: "",
      changeState: (props) => props?.title ?? props,
      alamatFieldKosong: {
        kelurahan: {
          id: 0,
          title: ""
        }
      },
      areaFieldKosong: {
        sub_district: []
      }
    },
    {
      key: "kelurahan",
      keyArea: "sub_district",
      disabled: !forms?.alamat?.kecamatan,
      placeholder: "Pilih Kelurahan",
      label: "Kelurahan",
      valueDropdown: forms?.alamat?.kelurahan?.title,
      zIndex: 2,
      defaultState: {
        id: 0,
        title: ""
      },
      changeState: (props) => {
        return {
          id: props?.id,
          title: props?.title ?? props,
          other_field: props?.other_field ?? {}
        };
      },
      alamatFieldKosong: {},
      areaFieldKosong: {}
    }
  ];

  let count = 0;

  const runGetOngkir = useCallback(async () => {
    try {
      setLoading((old) => ({
        ...old,
        getShipping: true
      }));

      const objCodeShipping = forms?.alamat?.kelurahan?.other_field
      const formatShipping = listAvailableShipping
        .filter((a) => shippingAvailableGet.some((aa) => aa == a.value))
        .reduce((acc, item) => {
          item.shipping_body.forEach((key) => {
            acc[key] =
              key === "ninja_l1"
                ? objCodeShipping?.kode_ninja_lt1 ?? ""
                : key === "ninja_l2"
                  ? objCodeShipping?.kode_ninja_lt2 ?? ""
                  : key === "lion_parcel"
                    ? objCodeShipping?.destination_lion_parcel_code ?? ""
                    : key === "sapx_destination"
                      ? objCodeShipping?.destination_sapx_code ?? ""
                      : key === "jne"
                        ? !objCodeShipping?.kode_origin_jne
                          ? objCodeShipping?.kode_destination_jne ?? ""
                          : objCodeShipping?.kode_origin_jne ?? ""
                        : objCodeShipping?.[`kode_${key}`] ||
                        objCodeShipping?.[key] ||
                        "";
          });
          return acc;
        }, {});

      const obj = {
        id_tujuan: formatShipping,
        item_price: Math.ceil(Number(datasModals?.total_price)), // total harga sebelum ongkir dan fee admin
        berat: getShippingWeight(datasModals?.total_weight ?? 0)
      };

      let dataOngkir = await getOngkir({
        body: { data: { ...obj } }
      });

      console.log(dataOngkir);

      const combinedItemsWithKey = Object.entries(dataOngkir ?? {})
        ?.map(([_, item]) => ({ _, item }))
        ?.reduce((combined, current) => {
          const key = current._;
          current.item.forEach((item) => {
            item.key = key;
            combined.push(item);
          });
          return combined;
        }, []);

      console.log(combinedItemsWithKey?.length);
      if (combinedItemsWithKey?.length <= 0) {
        count = count + 1;
        if (count >= 3) {
          count = 0;
          return toast.error(
            `Galat, silahkan pilih alamat penerima kembali!!`,
            settingToast
          );
        } else {
          console.log("galat count = $s", count);
          return runGetOngkir();
        }
      }
      count = 0;

      setListEkspedisi(combinedItemsWithKey);
    } catch (error) {
      toast.error(error?.message, settingToast);
    } finally {
      setLoading((old) => ({
        ...old,
        getShipping: false
      }));
    }
  }, [forms?.alamat?.kelurahan, count, listAvailableShipping, shippingAvailableGet]);

  const runGetShippingMarketplace = useCallback(async () => {
    setLoading((old) => ({ ...old, getSM: true }));
    try {
      let res = await getShippingMarketplace({});
      setListShippingMarketplace(res);
    } catch (error) {
      console.log(`error get shiping marketplace : ${error?.message}`);
      toast.error(`error get shiping marketplace : ${error?.message}`, {
        position: "top-center"
      });
    } finally {
      setLoading((old) => ({ ...old, getSM: false }));
    }
  }, [showDropdown]);

  const isListEkspedisi = listEkspedisi
    ?.filter?.(
      (item) =>
        (item?.key == "ninja" && item?.serviceName == "Sameday"
          ? item?.price > 0
          : item) &&
        (item?.key == "sicepat"
          ? validasiNameDate(item)?.name !== "KEPO"
          : item)
    )
    ?.map((item, index) => {
      let thisRajaOngkir = item?.rate_name?.toUpperCase();
      return {
        id: `${item?.key} ${validasiNameDate(item)?.field} ${validasiNameDate(item)?.name
          }`,
        title: `${item?.key == "rajaongkir"
          ? `RAJAONGKIR - ${thisRajaOngkir?.split(" ")[0]}`
          : item?.key?.replaceAll("_", ' ')?.toUpperCase()
          } - ${`${validasiNameDate(item)?.name?.toUpperCase()} ${validasiNameDate(item)?.date
          }`} - ${currency(item?.finalRate ?? item?.price)}`,
        value:
          item?.key == "rajaongkir"
            ? item?.rate_id
            : item?.serviceName ||
            item?.nameService ||
            item?.service_display ||
            item?.service ||
            item?.rate_name
      };
    })
    .filter((item) =>
      !forms?.pengiriman?.kurir
        ? item
        : item?.title
          .toLowerCase()
          ?.includes(forms?.pengiriman?.kurir?.toLowerCase())
    );

  const isListShippingMarketplace = listShippingMarketplace
    ?.map((item, index) => {
      return {
        id: index,
        title: item
      };
    })
    .filter((item) =>
      !forms?.pengiriman?.kurir
        ? item
        : item?.title
          .toLowerCase()
          ?.includes(forms?.pengiriman?.kurir?.toLowerCase())
    );

  async function handleRevisiShipping() {
    setLoading((old) => ({
      ...old,
      submitRevisiShipping: true
    }));
    try {
      let isEvents =
        metodePengiriman?.value !== "cod"
          ? metodePengirimanResi?.value
          : metodePengiriman?.value;

      if (!datasModals?.otherItem?.order_id) {
        throw new Error("Order ID is required");
      }
      if (!datasModals?.otherItem?.mitra_id) {
        throw new Error("Mitra ID is required");
      }

      if (!forms?.recipments_name) {
        handleChangeError("recipments_name")("Nama penerima wajib diisi");
        throw new Error("Nama penerima wajib diisi");
      }
      if (!forms?.recipments_telphone) {
        handleChangeError("recipments_telphone")(
          "No. Telp penerima wajib diisi"
        );
        throw new Error("No. Telp penerima wajib diisi");
      }
      if (!forms?.recipments_address) {
        handleChangeError("recipments_address")(
          "Alamat penerima tidak lengkap"
        );
        throw new Error("Alamat penerima tidak lengkap");
      } else if (forms?.recipments_address?.length < 16) {
        handleChangeError("recipments_address")(
          "Minimal detail alamat 16 karakter"
        );
        throw new Error("Minimal detail alamat 16 karakter");
      }

      if (isEvents == "resi_gon") {
        if (forms?.pengiriman?.chooseKurir.empty) {
          handleChangeError("ekspedisi")("Pilih ekspedisi terlebih dahulu");
          throw new Error("Ekspedisi not found");
        }

        if (!forms?.sender_name) {
          handleChangeError("sender_name")("Nama pengirim wajib diisi");
          throw new Error("Nama pengirim wajib diisi");
        }
        if (!forms?.sender_telphone) {
          handleChangeError("sender_telphone")("No. Telp pengirim wajib diisi");
          throw new Error("No. Telp pengirim wajib diisi");
        }
      }

      if (isEvents == "resi_marketplace") {
        if (!forms?.pengiriman?.kurir) {
          handleChangeError("ekspedisi")("Pilih ekspedisi terlebih dahulu");
          throw new Error("Ekspedisi not found");
        }

        if (!forms?.pengiriman?.noResi) {
          handleChangeError("noResi")("No resi wajib diisi");
          throw new Error("No resi wajib diisi");
        }
      }

      let isAreaId = forms?.alamat?.kelurahan?.id;

      if (!isAreaId) throw new Error("Lengkapi alamat terlebih dahulu");

      const body = {
        events: isEvents,
        order_id: datasModals?.otherItem?.order_id,
        mitra_id: datasModals?.otherItem?.mitra_id,
        area_id: isAreaId,
        shipping_info: {
          sender_name: forms?.sender_name,
          sender_telphone: forms?.sender_telphone,
          recipments_name: forms?.recipments_name,
          recipments_telphone: forms?.recipments_telphone,
          recipments_email: forms?.recipments_email,
          recipments_address: forms?.recipments_address
        },
        shipping_cost: forms?.pengiriman?.chooseKurir.empty
          ? {}
          : forms?.pengiriman?.chooseKurir,
        marketplace_info: {
          no_resi_marketplace: forms?.pengiriman?.noResi,
          name_kurir: forms?.pengiriman?.kurir
        }
      };

      let res = await updateAddressTransaction({
        token: session?.user?.token,
        ...body
      });

      if (!res.error) {
        await runGetListOrder();
        closeModal();
        setForms({});
        setAllowChangeAddress(false);
        return toast.success(res?.message, settingToast);
      }
      throw new Error(res?.error?.message || res?.error);
    } catch (error) {
      console.log(error?.message);
      toast.error(error?.message, {
        ...settingToast,
        autoClose: 5000
      });
    } finally {
      setLoading((old) => ({
        ...old,
        submitRevisiShipping: false
      }));
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <p className="subheading-semiBold text-greyscaleGON-400">Ubah Alamat</p>
        <Button
          label="batal"
          variants="outline"
          onClick={() => {
            setForms({});
            setAllowChangeAddress(false);
          }}
        />
      </div>
      <Divider />
      {metodePengiriman?.value !== "cod" && (
        <>
          <p className="p2-regular text-greyscaleGON-400">Informasi Penerima</p>
          {listFormDataPenerima?.map((item, index) => (
            <Input
              key={index}
              onChange={handleChange(item?.key)}
              value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
              disabled={item?.disable}
              placeholder={item?.placeholder}
              label={item?.label}
              error={!errors?.[item?.key] ? false : true}
              caption={errors?.[item?.key]}
              type={item?.typeInput}
              variants={item?.variants}
              handleDropdown={item?.handleDropdown}
              icon={item?.handleIcon}
            />
          ))}
          {listFormAlamatPenerima?.map((item, index) => (
            <div key={index} className={twMerge(`z-[${item?.zIndex}]`)}>
              <Input
                value={item?.valueDropdown}
                placeholder={item?.placeholder}
                disabled={item?.disabled}
                label={item?.label}
                onChange={(value) => {
                  setForms((old) => ({
                    ...old,
                    alamat: {
                      ...old?.alamat,
                      [item?.key]: item?.changeState(value)
                    },
                    ...(item?.keyArea == "sub_district"
                      ? {
                        pengiriman: {
                          ...old?.pengiriman,
                          kurir: "",
                          chooseKurir: {
                            empty: true
                          }
                        }
                      }
                      : {})
                  }));
                }}
                size="small"
                variants="dropdown"
                handleDropdown={{
                  show: showDropdown?.[`alamat_${item?.key}`],
                  showHIdden: () => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        [item?.key]: item?.defaultState
                      }
                    }));
                    handleDropdown(`alamat_${item?.key}`);
                  },
                  datas: isArea(item?.keyArea),
                  onChange: (value) => {
                    setForms((old) => ({
                      ...old,
                      alamat: {
                        ...old?.alamat,
                        ...item?.alamatFieldKosong,
                        [item?.key]: item?.changeState(value)
                      },
                      ...(item?.keyArea == "sub_district"
                        ? {
                          pengiriman: {
                            ...old?.pengiriman,
                            kurir: "",
                            chooseKurir: {
                              empty: true
                            }
                          }
                        }
                        : {})
                    }));
                    setArea((old) => ({
                      ...old,
                      ...item?.areaFieldKosong
                    }));
                  },
                  value: item?.valueDropdown
                }}
              />
            </div>
          ))}
          <Input
            onChange={handleChange("recipments_address")}
            value={forms?.recipments_address}
            placeholder={"Masukkan detail alamat penerima"}
            label={"Detail Alamat"}
            disableInput={!forms?.alamat?.kelurahan?.id}
            disabled={!forms?.alamat?.kelurahan?.id}
            variants="textarea"
            error={!errors?.recipments_address ? false : true}
            caption={errors?.recipments_address}
          />
          <Divider />
          <p className="p2-regular text-greyscaleGON-400">Metode Pengiriman</p>
          <div className="flex gap-4 items-center">
            {["resi_gon", "resi_marketplace", "cod"]?.map((a, b) => {
              let key = b + 2;
              return (
                <div
                  key={b}
                  className={twMerge("flex gap-1 items-center cursor-pointer")}
                  onClick={() => setIsMetodePengirimanResi({ key, value: a })}
                >
                  {metodePengirimanResi?.value == a ? (
                    <CheckboxCheckedSvg className="text-primaryGON-400 w-4 h-4" />
                  ) : (
                    <CheckboxUncheckSvg className="text-primaryGON-400 w-4 h-4" />
                  )}
                  <p className="p3-regular text-greyscaleGON-600 capitalize">
                    {a?.replaceAll("_", " ")}
                  </p>
                </div>
              );
            })}
          </div>
          <Divider />
          {metodePengirimanResi?.value == "resi_gon" ? (
            <>
              <p className="p2-regular text-greyscaleGON-400">Ekspedisi</p>
              <div className="flex flex-col gap-4">
                <InputTitle title={"Pilih Ekspedisi"} />
                {!forms?.alamat?.kelurahan?.id ? null : (
                  <div className="grid grid-cols-3 gap-4">
                    {listAvailableShipping?.map((a, b) => {
                      const isChecked = shippingAvailableGet.includes(a.value);
                      return (
                        <div
                          key={b}
                          onClick={() => {
                            setListEkspedisi([]);
                            showDropdown?.pengiriman_kurir &&
                              handleDropdown("pengiriman_kurir");

                            if (!isChecked) {
                              setShippingAvailableGet((old) => [
                                ...old,
                                a.value
                              ]);
                            } else {
                              setShippingAvailableGet((old) =>
                                old.filter((value) => value !== a.value)
                              );
                            }
                          }}
                          className="flex flex-row items-center gap-2"
                        >
                          <input type="checkbox" checked={isChecked} readOnly />{" "}
                          <p className="text-sm capitalize">
                            {a?.name?.replaceAll("_", " ")}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                )}
                <Input
                  value={forms?.pengiriman?.kurir}
                  status={
                    errors?.pengiriman?.kurir?.toString()?.length > 0
                      ? "error"
                      : "normal"
                  }
                  disableInput={
                    !forms?.alamat?.kelurahan?.id ||
                    loading?.getShipping ||
                    !shippingAvailableGet ||
                    shippingAvailableGet?.length <= 0
                  }
                  placeholder={
                    loading?.getShipping
                      ? "loading..."
                      : "Pilih Ekspedisi pengiriman"
                  }
                  onChange={handleChange("pengiriman_kurir")}
                  disabled={
                    !forms?.alamat?.kelurahan?.id ||
                    loading?.getShipping ||
                    !shippingAvailableGet ||
                    shippingAvailableGet?.length <= 0
                  }
                  variants="dropdown"
                  handleDropdown={{
                    show: showDropdown?.pengiriman_kurir,
                    showHIdden: () => {
                      if (!showDropdown?.pengiriman_kurir) {
                        if (
                          listEkspedisi?.length <= 0 ||
                          isIdArea !== forms?.alamat?.kelurahan?.id
                        ) {
                          runGetOngkir();
                          setIsIdArea(forms?.alamat?.kelurahan?.id);
                        }
                      }
                      setForms((old) => ({
                        ...old,
                        pengiriman: {
                          ...old?.pengiriman,
                          kurir: "",
                          chooseKurir: {
                            empty: true
                          }
                        }
                      }));
                      handleDropdown("pengiriman_kurir");
                    },
                    datas: isListEkspedisi,
                    onChange: (value) => {
                      const idSplit = value?.id?.split(" ");
                      const chooseKurir = listEkspedisi?.filter(
                        (item) =>
                          item?.key == idSplit[0] &&
                          item[idSplit[1]] == value?.value
                      )?.[0];
                      setForms((old) => ({
                        ...old,
                        pengiriman: {
                          ...old?.pengiriman,
                          chooseKurir,
                          kurir: value?.title
                        }
                      }));
                    },
                    value: forms?.pengiriman?.kurir
                  }}
                  error={!errors?.ekspedisi ? false : true}
                  caption={errors?.ekspedisi}
                />
              </div>
              <Divider />
              <p className="p2-regular text-greyscaleGON-400">
                Informasi Pengirim
              </p>
              {listFormDataPengirim?.map((item, index) => (
                <Input
                  key={index}
                  onChange={handleChange(item?.key)}
                  value={forms?.[item?.key]?.title ?? forms?.[item?.key]}
                  disabled={item?.disable}
                  placeholder={item?.placeholder}
                  label={item?.label}
                  error={!errors?.[item?.key] ? false : true}
                  caption={errors?.[item?.key]}
                  type={item?.typeInput}
                  variants={item?.variants}
                  handleDropdown={item?.handleDropdown}
                  icon={item?.handleIcon}
                />
              ))}
            </>
          ) : metodePengirimanResi?.value == "resi_marketplace" ? (
            <>
              <p className="p2-regular text-greyscaleGON-400">Ekspedisi</p>
              <div className="flex flex-col gap-4 z-[8]">
                <Input
                  value={forms?.pengiriman?.kurir}
                  status={
                    errors?.pengiriman?.kurir?.toString()?.length > 0
                      ? "error"
                      : "normal"
                  }
                  disableInput={!forms?.alamat?.kelurahan?.id || loading?.getSM}
                  placeholder={
                    loading?.getSM ? "loading..." : "Pilih Ekspedisi pengiriman"
                  }
                  label={"Pilih Ekspedisi"}
                  onChange={handleChange("pengiriman_kurir")}
                  disabled={!forms?.alamat?.kelurahan?.id || loading?.getSM}
                  variants="dropdown"
                  handleDropdown={{
                    show: showDropdown?.pengiriman_kurir,
                    showHIdden: () => {
                      if (!showDropdown?.pengiriman_kurir) {
                        isListShippingMarketplace?.length <= 0 &&
                          runGetShippingMarketplace();
                      }
                      setForms((old) => ({
                        ...old,
                        pengiriman: {
                          ...old?.pengiriman,
                          kurir: ""
                        }
                      }));
                      handleDropdown("pengiriman_kurir");
                    },
                    datas: isListShippingMarketplace,
                    onChange: (value) => {
                      setForms((old) => ({
                        ...old,
                        pengiriman: {
                          ...old?.pengiriman,
                          kurir: value?.title
                        }
                      }));
                    },
                    value: forms?.pengiriman?.kurir
                  }}
                  error={!errors?.ekspedisi ? false : true}
                  caption={errors?.ekspedisi}
                />
              </div>
              <div className="flex flex-col gap-4">
                <Input
                  value={forms?.pengiriman?.noResi}
                  onChange={(val) => {
                    let value = val?.replace(/[^A-Za-z0-9-]/g, "");
                    setForms((old) => ({
                      ...old,
                      pengiriman: { ...old?.pengiriman, noResi: value }
                    }));
                  }}
                  status={
                    errors?.pengiriman?.noResi?.toString()?.length > 0
                      ? "error"
                      : "normal"
                  }
                  disabled={!forms?.pengiriman?.kurir}
                  placeholder="Masukkan Nomor Resi Marketplace"
                  label={"Nomor Resi"}
                />
              </div>
            </>
          ) : null}
        </>
      )}
      <Divider />
      <div className="flex flex-row items-center gap-4 w-full">
        <Button
          label="batal"
          variants="outline"
          disable={loading.submitRevisiShipping}
          onClick={() => {
            setForms({});
            setAllowChangeAddress(false);
          }}
        />
        <Button
          label="Simpan perubahan"
          className="w-full"
          loading={loading.submitRevisiShipping}
          disable={loading.submitRevisiShipping}
          onClick={() => handleRevisiShipping()}
        />
      </div>
    </div>
  );
};
